import settings from 'settings'
import { api } from 'app/views/utils/api'

const LOAD_COMPLETED_REPORT = 'reports/LOAD_COMPLETED_REPORT'
const LOAD_INCOMPLETED_REPORT = 'reports/LOAD_INCOMPLETED_REPORT'
const LOAD_MASTERY_REPORT = 'reports/LOAD_MASTERY_REPORT'
const LOAD_CHALLENGES_REPORT = 'reports/LOAD_CHALLENGES_REPORT'
const SET_COMPLETED_REPORT = 'reports/SET_COMPLETED_REPORT'
const SET_CHALLENGES_REPORT = 'reports/SET_CHALLENGES_REPORT'
const SET_INCOMPLETED_REPORT = 'reports/SET_INCOMPLETED_REPORT'
const SET_MASTERY_REPORT = 'reports/SET_MASTERY_REPORT'

const initialState = {
  completedReport: 'loading',
  incompletedReport: 'loading',
  masteryReport: 'loading',
  challengesReport: 'loading',
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CHALLENGES_REPORT:
      return {
        ...state,
        challengesReport: action.challengesReport,
      }
    case SET_MASTERY_REPORT:
      return {
        ...state,
        masteryReport: action.masteryReport,
      }
    case SET_COMPLETED_REPORT:
      return {
        ...state,
        completedReport: action.completedReport,
      }
    case SET_INCOMPLETED_REPORT:
      return {
        ...state,
        incompletedReport: action.incompletedReport,
      }
    case LOAD_COMPLETED_REPORT:
      return {
        ...state,
        completedReport: 'loading',
      }
    case LOAD_CHALLENGES_REPORT:
      return {
        ...state,
        challengesReport: 'loading',
      }
    case LOAD_INCOMPLETED_REPORT:
      return {
        ...state,
        incompletedReport: 'loading',
      }
    case LOAD_MASTERY_REPORT:
      return {
        ...state,
        masteryReport: 'loading',
      }

    default:
      return state
  }
}

export function getTrainingTimeOverTimeChart(organizationUUID) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationUUID}/report/training_time_chart`,
      idToken: state.auth.user.idToken,
    })
  }
}

export function getMasteryChartReport(organizationUUID) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationUUID}/report/mastery_chart`,
      idToken: state.auth.user.idToken,
    })
  }
}

export function getCategoryTimeChartReport(organizationUUID) {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.hacker}/organizations/${organizationUUID}/report/category_time_chart`,
      idToken: state.auth.user.idToken,
    })
  }
}

export function getCompletedReport(organizationId, teamId = null) {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_COMPLETED_REPORT,
    })
    const state = getState()
    const url = teamId ? `${settings.urls.hacker}/organizations/${organizationId}/teams/${teamId}/report/completed` : `${settings.urls.hacker}/organizations/${organizationId}/report/completed`
    return api({
      method: 'get',
      url,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: SET_COMPLETED_REPORT,
          completedReport: data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getIncompletedReport(organizationId, teamId = null) {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_INCOMPLETED_REPORT,
    })
    const state = getState()
    const url = teamId ? `${settings.urls.hacker}/organizations/${organizationId}/teams/${teamId}/report/incompleted` : `${settings.urls.hacker}/organizations/${organizationId}/report/incompleted`

    return api({
      method: 'get',
      url,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: SET_INCOMPLETED_REPORT,
          incompletedReport: data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getMasteryReport(organizationId, teamId = null) {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_MASTERY_REPORT,
    })
    const url = teamId ? `${settings.urls.hacker}/organizations/${organizationId}/teams/${teamId}/report/mastery` : `${settings.urls.hacker}/organizations/${organizationId}/report/mastery`

    const state = getState()
    return api({
      method: 'get',
      url,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: SET_MASTERY_REPORT,
          masteryReport: data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getChallengesReport(organizationId, teamId = null) {
  return (dispatch, getState) => {
    dispatch({
      type: LOAD_CHALLENGES_REPORT,
    })
    const url = teamId ? `${settings.urls.hacker}/organizations/${organizationId}/teams/${teamId}/report/challenges` : `${settings.urls.hacker}/organizations/${organizationId}/report/challenges`
    const state = getState()
    return api({
      method: 'get',
      url,
      idToken: state.auth.user.idToken,
    })
      .then(({ data }) => {
        dispatch({
          type: SET_CHALLENGES_REPORT,
          challengesReport: data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
